<template>
  <div class="ai-seg" :style="{ '--n': options.length }">
    <div class="glow" :style="glowStyle"></div>
    <button v-for="(o, i) in options" :key="o.value" type="button"
            class="seg-btn" :class="{ active: value === o.value, danger: o.danger && value === o.value }"
            @click="$emit('input', o.value)">
      <span class="seg-label">{{ o.label }}</span>
      <span v-if="o.hint" class="seg-hint">{{ o.hint }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AiSegmented',
  props: {
    value: { type: [String, Number], default: null },
    // [{ value, label, hint?, danger? }]
    options: { type: Array, required: true },
  },
  computed: {
    activeIndex() { return Math.max(0, this.options.findIndex(o => o.value === this.value)); },
    activeOpt() { return this.options[this.activeIndex] || {}; },
    glowStyle() {
      return {
        width: `calc((100% - 8px) / var(--n))`,
        transform: `translateX(calc(${this.activeIndex} * 100%))`,
        background: this.activeOpt.danger ? '#fee2e2' : '#fff',
      };
    },
  },
};
</script>

<style scoped>
.ai-seg {
  position: relative; display: grid; grid-template-columns: repeat(var(--n), 1fr);
  background: #eef2f7; border: 1px solid #e2e8f0; border-radius: 12px; padding: 4px;
}
.glow {
  position: absolute; top: 4px; bottom: 4px; left: 4px; border-radius: 9px;
  box-shadow: 0 1px 3px rgba(0,0,0,.1); transition: transform .25s cubic-bezier(.34,1.3,.5,1), background .2s;
}
.seg-btn {
  position: relative; z-index: 1; background: none; border: 0; cursor: pointer;
  padding: 8px 10px; border-radius: 9px; text-align: center;
  display: flex; flex-direction: column; gap: 1px; line-height: 1.2;
  color: #64748b; transition: color .2s;
}
.seg-btn.active { color: #1e293b; }
.seg-btn.danger { color: #dc2626; }
.seg-label { font-size: 13px; font-weight: 600; }
.seg-hint { font-size: 10.5px; opacity: .7; font-weight: 400; }
</style>
